<template>
    <b-container fluid>
        <hr/>
        <h3>{{name}}</h3>
        <hr/>
        <b-button @click="goBack">Back</b-button>
        <hr/>
        <v-skeleton-loader
                :loading="this.loadingIndex"
                transition='fade-transition'
                ref="skeleton"
                type="table"
                class="mx-auto"
                width="100%">
            <b-table striped :items="connections" :fields="['connection_name', 'manage']">
                <template slot="manage" slot-scope="data">
                    <b-button @click="openManager(data.item)" variant="primary">Manage</b-button>
                </template>
            </b-table>
        </v-skeleton-loader>

        <acumulus-manager v-bind:project_data="project_data"
                          @acumulus-authorization-complete="onUpdateConnections">
        </acumulus-manager>
        <exact-manager v-bind:project_data="project_data"
                       @exact-authorization-complete="onUpdateConnections"
                       @exact-credentials-cleared="onUpdateConnections">
        </exact-manager>
        <shopware-manager v-bind:project_data="project_data"
                          @shopware-authorization-complete="onUpdateConnections">
        </shopware-manager>
        <shopware6-manager v-bind:project_data="project_data"
                           @shopware-authorization-complete="onUpdateConnections">
        </shopware6-manager>
        <snel-start-v2 v-bind:project_data="project_data"
                       @snelstartV2-authorization-complete="onUpdateConnections">
        </snel-start-v2>
        <winstore-manager v-bind:project_data="project_data"
                          @winstore-authorization-complete="onUpdateConnections">
        </winstore-manager>
    </b-container>
</template>

<script>
    import ProjectRepository from '../../repositories/project.repository';
    import AcumulusManager from "./managers/Acumulus";
    import ExactManager from './managers/Exact.vue';
    import ShopwareManager from './managers/Shopware.vue';
    import Shopware6Manager from './managers/Shopware6.vue';
    import SnelStartV2 from "./managers/SnelStartV2.vue";
    import WinstoreManager from "./managers/Winstore.vue";

    export default {
        data() {
            return {
                name: 'Connections',
                connections: [
                    {connection_name: 'Acumulus', modal_id: 'acumulus_manager_modal'},
                    {connection_name: 'Exact Online', modal_id: 'exact_manager_modal'},
                    {connection_name: 'Shopware 5.6', modal_id: 'shopware_manager_modal'},
                    {connection_name: 'Shopware 6', modal_id: 'shopware6_manager_modal'},
                    {connection_name: 'SnelStart V2', modal_id: 'snelstartV2_manager_modal'},
                    {connection_name: 'Winstore', modal_id: 'winstore_manager_modal'},
                ],
                project_data: {
                    connections: []
                },
                loadingIndex: false,
            }
        },
        components: {
            AcumulusManager,
            SnelStartV2,
            ExactManager,
            ShopwareManager,
            Shopware6Manager,
            WinstoreManager
        },
        methods: {
            openManager(data) {
                this.$bvModal.show(data.modal_id);
            },
            onUpdateConnections(project_id) {
                this.$emit('show-loading-pop-up', 'Updating the connections info.');
                ProjectRepository.getConnections(project_id).then(res => {
                    this.project_data = res.data.project_data;
                    this.$emit('reset-loading-pop-up');
                }).catch(error => {
                    this.$emit('reset-loading-pop-up');
                });
            },
            goBack() {
                this.$router.push({path: `/projects`});
            }
        },
        created() {
            this.loadingIndex = true;
            ProjectRepository.getConnections(this.$route.params.id).then(res => {
                this.loadingIndex = false;
                this.name = 'Manage ' + res.data.project_data.name + ' connections';
                this.project_data = res.data.project_data;
            }).catch(error => {
                this.loadingIndex = false
            });
        }
    }
</script>
